import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { EntityState, serializeAxiosError, IQueryParams } from 'app/shared/reducers/reducer.utils';
import { IIndicatorDto, defaultValue } from 'app/shared/model/indicator-dto.model';
import { IKpiTiresDto, IKpiTiresResponse } from 'app/shared/model/indicator-dto';

const initialState: EntityState<IIndicatorDto> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};
export interface IIndicatorAlertTiresProps extends IQueryParams {
  companyId?: number | null;
}

const apiUrl = '/api/indicator-tires/alert';

// Actions

export const getIndicatorTiresAlertsCards = createAsyncThunk(
  'indicatorTiresAlerts/fetch_indicator_tires_alerts_cards',
  async ({ companyId }: IIndicatorAlertTiresProps) => {
    const apiUrlComplete = `${apiUrl}/statistics${companyId ? `?searchCompanyId=${companyId}` : ''}`;
    const response = await axios.get<IKpiTiresDto[]>(apiUrlComplete);
    return response.data;
  },
  { serializeError: serializeAxiosError }
);

export const getIndicatorTiresAlertsChart = createAsyncThunk(
  'indicatorTiresAlerts/fetch_indicator_tires_alerts_chart',
  async ({ companyId }: IIndicatorAlertTiresProps) => {
    const apiUrlComplete = `${apiUrl}/time${companyId ? `?searchCompanyId=${companyId}` : ''}`;
    const response = await axios.get<IKpiTiresResponse>(apiUrlComplete);
    return response.data;
  },
  { serializeError: serializeAxiosError }
);

// Slice

const indicatorTiresAlertSlice = createSlice({
  name: 'indicatorTiresAlerts',
  initialState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getIndicatorTiresAlertsCards.fulfilled, (state, action) => {
        state.loading = false;
        state.entity.kpiTires = action.payload;
      })
      .addCase(getIndicatorTiresAlertsCards.pending, state => {
        state.loading = true;
      })
      .addCase(getIndicatorTiresAlertsCards.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message || 'Error fetching data';
      })
      .addCase(getIndicatorTiresAlertsChart.fulfilled, (state, action) => {
        state.loading = false;
        state.entity.kpiTiresResponse = action.payload;
      })
      .addCase(getIndicatorTiresAlertsChart.pending, state => {
        state.loading = true;
      })
      .addCase(getIndicatorTiresAlertsChart.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message || 'Error fetching data';
      });
  },
});

export const { reset } = indicatorTiresAlertSlice.actions;

export default indicatorTiresAlertSlice.reducer;
